<template lang="pug">
  div(class='container' v-loading="deleting")
    div.page-title(v-if='opts.displayName'
      :class="{'titlefixed':opts.editable && opts.recycle}"
      :title="opts.displayName")
      | {{opts.displayName}} ({{dataCount}})
      slot(name='goto')
      actionbar(:opts="opts"
        :columnHidden="columnHidden"
        @create="create"
        @share="share"
        @remove="remove"
        @setColumnHidden="setColumnHidden"
        @hideRow="hideRow")
        template(slot='actions')
          slot(name="actions")

    popover(v-if="opts.delbtn"  text='删除' style="text-align: right;")
      div 删除选中的行？
      div.a(@click='remove') 确定

    //- div.recycler(ref='container' :class="{mgtop:opts.recycle}")

    div.cell-bar(ref="actionbar" v-if="opts.actionbar")
      search-box(ref='searchBox')
      template(v-if="opts.editable")
        input.cell-bar-input(
          v-model="expandedEditorContent"
          @keyup="onExpandedEditorContentChange"
          @focus="expandedEditorEditing=true"
          @blur="expandedEditorEditing=false"
        )
      div.cell-bar-option(v-if="opts.rowActions && showActiveRow")
        span 第{{parseInt(activeRow.row)+1}}行:
        a(v-for="v in opts.rowActions", @click="v.handler(activeRow)") {{v.text}}
      div.cell-bar-filter
        el-tag(v-for="(v, k) in filterby" v-if="v!=''" :key="k"
          type="gray" :closable="true" @close="removeFilter(k)")
          template(v-if="v=='$null'") [{{k}}] 为空
          template(v-else-if="v=='$notnull'") [{{k}}] 非空
          template(v-else-if="v.indexOf('@')!=-1") [{{k}}] 不等于 "{{v.substr(1)}}"
          template(v-else-if="v.indexOf('/')!=-1") [{{k}}] 等于 "{{v.split('/').join('\"或\"')}}"
          template(v-else) [{{k}}] 包含 "{{v}}"
      div.cell-bar-filter(v-if="sortby")
        el-tag(v-for="v,label in sortby"
          type="gray" :closable="true" @close="unsort()" :key="label")
          | 按照{{label}}{{(v>0)?'升序':'降序'}}排序

      div.cell-bar-status(style="text-align: right;")
        | {{status}}

    div(style="overflow:hidden", ref='title')
      table.spsheet(style="table-layout:fixed;")
        tr.spheader(style="overflow:hidden;")
          td(width="30px", v-if="opts.checkable")
            el-checkbox.chk(v-model="selected" @change="onCheckall(selected)")
          td(width="50px", v-if="opts.numable")
          template(v-for="(v, col) in shownColumns")
            td(v-if="v", :width="v.width")
              table-column-title.spheader(
                :opts="opts"
                :shownColumns="shownColumns"
                :filterby="filterby"
                @filter="init(true)"
                @search="search"
                @sort="sort"
                :col="col" :v="v")
          td(v-if="scrollerY" width="15px")
    div.scroller(:style='scrollerStyle', v-on:scroll='onscroll', ref='scroller')
      table.spsheet(v-if="dataReady" style="table-layout:fixed;")
        tr.holder(style="height:0px;overflow:hidden", height=0)
          td(width="30px", v-if="opts.checkable")
          td(width="50px", v-if="opts.numable")
          template(v-for="(w, col) in shownColumns")
            td(v-if="w", :width="w.width")

        tr(:style="'height:'+headerHeight+';overflow:hidden;'")
        template(v-for="(v, row) in dataDisplayed")
          tr(ref='tableRow', :key='start+row', :style="rowStyle(v,row)")
            td(width="40px", v-if="opts.checkable")
              el-checkbox.chk(v-model="v.checked" :row="row" @change="onCheckboxChange(row, v.checked)")
            td(width="50px", v-if="opts.numable")
              table-row-title(:opts='opts', :data="v", :row="row+start" @insert="insert" @yell="yell" @doExpand="doExpand")
            template(v-for="(w, col) in shownColumns")
              td(v-if="w" ref='cells' :row="row" :col="col"
                @click="cellClick"
                @mouseover="onMouseoverCell")
                div(
                  v-if="opts.recycle && !v.rendered[shownColumns[col].label] && (v.html[shownColumns[col].label]) && shownColumns[col].cache != 'disabled'"
                  v-html="v.html[shownColumns[col].label]")
                //- div(v-else-if="opts.recycle && !v.rendered[shownColumns[col].label] && !shownColumns[col].display && shownColumns[col].type!='session' && shownColumns[col].type!='cv' && !shownColumns[col].text && !shownColumns[col].text && !shownColumns[col].asterisk && (!shownColumns[col].type || !v[shownColumns[col].label])"
                //-   :title="v[shownColumns[col].label]")
                //-   div(ref="placeholder")
                //-   pre.pre(:title="v[shownColumns[col].label]") {{v[shownColumns[col].label]}}
                table-cell(v-else
                  mode="body"
                  :opts="opts"
                  :shownColumns="shownColumns"
                  :row="start+row"
                  :col="col"
                  :rowObj="v"
                  @change="onCellChange"
                )
        tr(:style="'height:'+footerHeight+';overflow:hidden'")
    div.meng(v-if="expanded" @click="disExpand")
    div.row-detail
      div.detail-close(v-if="expanded" @click="disExpand")
        i.el-icon-close
      table-detail.col(
        v-if="expanded"
        :opts='opts'
        :data='expandRowData'
        :row="parseInt(expandRowData.row)"
      )
    ul.right-click-menu(ref="menu" tabindex='-1', v-if='viewMenu', @blur='closeMenu', :style="{position:'absolute', top:top,left:left}")
      li First list item
      li Second list item
</template>

<script>
// Generated by CoffeeScript 2.3.0
import Vue from 'vue'

import tableCell from './cell.vue'
import tableRowTitle from './row-title.vue'
import tableColumnTitle from './column-title.vue'
import searchBox from './search-box.vue'
import tableDetail from './detail.vue'
import actionbar from './actionbar.vue'
import datautils from './datautils'

let addClass, hasClass, m, removeClass, sandbox

hasClass = (obj, cls) => obj.className.match(new RegExp(`(\\s|^)${cls}(\\s|$)`))

addClass = (obj, cls) => {
  if (!hasClass(obj, cls)) {
    return (obj.className += ` ${cls}`)
  }
}

removeClass = (obj, cls) => {
  let reg
  if (hasClass(obj, cls)) {
    reg = new RegExp(`(\\s|^)${cls}(\\s|$)`)
    return (obj.className = obj.className.replace(reg, ' '))
  }
}

sandbox = document.createElement('div')

sandbox.innerHTML = '<div></div>'

sandbox.style.display = 'None'

export default (m = {
  components: {
    'table-cell': tableCell,
    'table-row-title': tableRowTitle,
    'table-column-title': tableColumnTitle,
    'search-box': searchBox,
    'table-detail': tableDetail,
    actionbar,
  },
  mixins: [datautils],
  props: {
    opts: Object,
    refreshFilter: false,
  },
  data() {
    let base, base1, base2, base3, base4, base5, columnHidden, data, filterby, name, name1, rowHidden, shownColumns
    if ((base = app.config.cfg.spreadsheet)[(name = this.opts.tableName)] == null) {
      base[name] = {}
    }
    if ((base1 = app.config.cfg.spreadsheet[this.opts.tableName]).columnHidden == null) {
      base1.columnHidden = {}
    }
    columnHidden = app.config.cfg.spreadsheet[this.opts.tableName].columnHidden
    this.opts.columns.map(col => {
      let name1
      return columnHidden[(name1 = col.label)] != null ? columnHidden[name1] : (columnHidden[name1] = !!col.hidden)
    })
    shownColumns = this.opts.columns.filter(v => !v.hideInSheet && !columnHidden[v.label])
    // console.log @opts.columns, shownColumns
    if ((base2 = this.opts).cfgId == null) {
      base2.cfgId = ''
    }
    if ((base3 = app.config.cfg.spreadsheet)[(name1 = this.opts.tableName + this.opts.cfgId)] == null) {
      base3[name1] = {}
    }
    if ((base4 = app.config.cfg.spreadsheet[this.opts.tableName + this.opts.cfgId]).filterby == null) {
      base4.filterby = {}
    }
    if ((base5 = app.config.cfg.spreadsheet[this.opts.tableName + this.opts.cfgId]).rowHidden == null) {
      base5.rowHidden = {}
    }
    rowHidden = app.config.cfg.spreadsheet[this.opts.tableName + this.opts.cfgId].rowHidden
    if (this.opts.filterCacheable) {
      filterby = app.config.cfg.spreadsheet[this.opts.tableName + this.opts.cfgId].filterby
    }
    if (!filterby) {
      filterby = {}
    }
    return (data = {
      start: 0,
      end: 0,
      checkAll: false,
      isIndeterminate: false,
      checkedItems: [],
      deleting: false,
      selected: false,
      title: {
        opts: this.opts,
        checked: false,
      },
      headerHeight: 0,
      footerHeight: 0,
      scrollerHeight: 0,
      scrollerWidth: 0,
      debug: 'debug',
      dataDisplayed: [],
      highlightRow: 0,
      highlightCol: 0,
      titleLeft: 0,
      filteredData: [],
      filterby: filterby,
      cells: [],
      cache: {},
      expandedEditorContent: '',
      expandedEditorFocused: false,
      cellEditing: null,
      expanded: false,
      expandRowData: {},
      rowHeight: 29,
      status: '',
      activeRow: {},
      showActiveRow: false,
      activeRowNum: null,
      mouseOverRowNum: null,
      cellProps: {},
      dataReady: false,
      // data: []
      dataCount: 0,
      count: 0,
      rowHidden: rowHidden,
      columnHidden: columnHidden,
      shownColumns: shownColumns,
      checkedAll: false,
      filteredData: [],
      pageBegin: 0,
      itemCount: 0,
      minute: 2,
      searchby: '',
      sortby: '',
      viewMenu: false,
      left: '0px',
      top: '0px',
    })
  },
  computed: {
    scrollerY() {
      if (this.opts.scrollerY === false) {
        return this.opts.scrollerY
      } else {
        return this.scrollerHeight < this.dataCount * 29
      }
    },
    scrollerStyle() {
      let style
      style = {}
      if (this.opts.editable && !this.opts.scrollerY) {
        style = {
          maxHeight: `${this.scrollerHeight}px`,
        }
      }
      if (!this.scrollerY) {
        style.overflowY = 'hidden'
      } else {
        style.overflowY = 'auto'
      }
      return style
    },
  },
  methods: {
    yell(msg) {
      return this.$emit('yell', msg)
    },
    rowStyle(item, row) {
      if (item.checked) {
        return {
          'background-color': '#ddd',
        }
      } else if (this.activeRowNum === this.start + row) {
        return {
          'background-color': '#F4EFFA',
        }
      } else if (item['职能模块'] && item['职能模块'].indexOf('?') !== -1) {
        return {
          'background-color': '#fcc',
        }
      } else if (this.mouseOverRowNum === row) {
        return {
          'background-color': '#EFF4FA',
        }
      }
    },
    // else if row % 2 == 0
    //   'background-color': '#f8f8f8'
    logScrollTop() {
      this.scrollTopData = this.$refs.scroller.scrollTop
      return this.scrollTopData
    },
    recoverScrollTop(st) {
      if (st == null) {
        st = this.scrollTopData
      }
      return this.scrollFrame(0, st)
    },
    yell(msg) {
      return this.$emit('yell', msg) // 将选中的数据移动到下一行需要 勿删
    },
    removeStatus: _.debounce(function() {
      return (this.status = '')
    }, 3000),
    setStatus(status) {
      this.status = status
      return this.removeStatus()
    },
    setColumnHidden(k) {
      this.shownColumns = this.opts.columns.filter(v => !v.hideInSheet && !this.columnHidden[v.label])
      app.config.save()
      return this.init()
    },
    updateIndex() {
      let ref
      this.cells = {}
      return (ref = this.$refs.cells) != null
        ? ref.map(cell => {
            let base, col, name, row
            row = parseInt(cell.getAttribute('row'))
            col = parseInt(cell.getAttribute('col'))
            if ((base = this.cells)[(name = this.start + row)] == null) {
              base[name] = {}
            }
            return (this.cells[this.start + row][col] = cell)
          })
        : void 0
    },
    onExpandedEditorContentChange() {
      let ref
      if (!this.cellEditing) {
        return
      }
      return (ref = this.cellEditing) != null ? ref.update(this.expandedEditorContent) : void 0
    },
    onCellChange: function(expandedEditorContent, cellEditing) {
      this.expandedEditorContent = expandedEditorContent
      this.cellEditing = cellEditing
    },
    log_performance(data) {},
    // app.api.create
    //   account: app.user.account
    //   tableName: 'logs_ss_performance'
    //   data: data
    rerender() {
      return new Promise(resolve => {
        this.dataReady = false
        return this.$nextTick(() => {
          this.dataReady = true
          return this.$nextTick(() => resolve())
        })
      })
    },
    resize() {
      this.scrollerHeight = window.innerHeight - this.$refs.scroller.offsetTop
      return (this.scrollerWidth = window.innerWidth)
    },
    update(forced = false, prerender = 10, threshold = 0) {
      let count, end, start, t, t0
      t0 = Date.now() // app.tic 't0'
      if (!this.opts.recycle) {
        prerender = 20000000
      }
      this.resize()
      if (!this.data) {
        return
      }
      count = this.data.length
      t = this.$refs.scroller.scrollTop
      start = t / this.rowHeight - prerender
      start = Math.max(Math.floor(start), 0)
      end = t / this.rowHeight + this.scrollerHeight / this.rowHeight + prerender
      end = Math.min(Math.floor(end), count)
      if (forced === 'forced' || Math.abs(start - this.start) > threshold || Math.abs(end - this.end) > threshold) {
        t0 = Date.now() // app.tic 't0'
        return this.load(start, end).then(data => {
          let t1
          t1 = Date.now() - t0
          data.map((item, k) => (item.checked = this.data[start + k].checked))
          this.dataDisplayed = data
          this.start = start
          this.end = end
          this.headerHeight = `${this.start * this.rowHeight}px`
          this.footerHeight = `${(count - this.end) * this.rowHeight}px`
          return this.$nextTick(() => {
            let t2
            t2 = Date.now() - t0
            this.setStatus(`t=${(t2 / 1000).toFixed(2)}`)
            // console.log "Update t1 = #{t1}, t2 = #{t2}"
            return this.updateIndex()
          })
        })
      }
    },
    onscroll(e) {
      let scrollLength
      this.$refs.title.scrollLeft = this.$refs.scroller.scrollLeft
      if (this.busy == null) {
        this.busy = false
      }
      if (this.timeout == null) {
        this.timeout = null
      }
      if (this.lastUpdate == null) {
        this.lastUpdate = null
      }
      this.scrollTitle()
      if (this.busy) {
        return
      }
      // console.log @$refs.scroller.scrollTop
      // console.log @lastTop
      scrollLength = Math.abs(this.$refs.scroller.scrollTop - this.lastTop)
      // console.log scrollLength
      if (scrollLength < 200) {
        return
      }
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      return (this.timeout = setTimeout(() => {
        this.busy = true
        this.update()
        this.timeout = null
        return this.$nextTick(() => {
          this.busy = false
          this.lastTop = this.$refs.scroller.scrollTop
          return (this.lastUpdate = Date.now())
        }, 10)
      }, 50))
    },
    rowExist(row) {
      return this.cells[row]
    },
    scrollInToView(cell) {
      let cx, cy, scroller
      scroller = this.$refs.scroller
      if (scroller) {
        cy = cell.offsetTop - scroller.scrollTop
        cx = cell.offsetLeft - scroller.scrollLeft
        if (cy < 50) {
          scroller.scrollTop = cell.offsetTop - 50
        }
        if (cy > this.scrollerHeight - 50) {
          scroller.scrollTop = cell.offsetTop - this.scrollerHeight + 60
        }
        if (cx < 50) {
          scroller.scrollLeft = cell.offsetLeft - 40
        }
        if (cx > this.scrollerWidth - cell.scrollWidth - 50) {
          return (scroller.scrollLeft = cell.offsetLeft - this.scrollerWidth + cell.scrollWidth + 60)
        }
      }
    },
    cellToIndex(cell) {
      let col, row
      row = parseInt(cell.getAttribute('row'))
      col = parseInt(cell.getAttribute('col'))
      return { row, col }
    },
    indexToComp(row, col) {
      return this.cells[this.start + row][col].childNodes[0].__vue__
    },
    eventToCell(e) {
      let target
      target = e.path.filter(dom => dom.tagName === 'TD')
      return target[0]
    },
    onMouseoverCell(e) {
      let cell, col, row
      cell = this.eventToCell(e)
      row = parseInt(cell.getAttribute('row'))
      col = parseInt(cell.getAttribute('col'))
      this.mouseOverRowNum = row
      return this.renderCell(row, col)
    },
    renderCell(row, col, value) {
      return new Promise((resolve, reject) => {
        let comp, label
        comp = this.indexToComp(row, col)
        if (comp) {
          value != null && comp.render(value)
          return resolve()
        } else {
          label = this.shownColumns[col].label
          this.dataDisplayed[row].rendered[label] = true
          return this.$nextTick(resolve)
        }
      })
    },
    cellClick(e) {
      let cell, col, row
      if (e.target.tagName !== 'TEXTAREA') {
        // 沟通备注上方textarea
        cell = this.eventToCell(e)
        ;({ row, col } = this.cellToIndex(cell))
        return this.highlight(this.start + row, col)
      }
    },
    dishighlight() {
      let comp1
      if (this.highlightedCell) {
        removeClass(this.highlightedCell, 'highlight')
        this.showActiveRow = false
        this.activeRowNum = null
        comp1 = this.highlightedCell.childNodes[0].__vue__
        if (comp1) {
          // {r, c} = @cellToIndex @highlightedCell
          // if row != r || col != c
          if (comp1.editing) {
            comp1.blur()
          }
          return removeClass(this.highlightedCell, 'highlight')
        }
      }
    },
    highlight(row, col, edit = true, scroll = true) {
      let cell, comp, p, ref, ref1
      if (!this.opts.editable) {
        return false
      }
      if (row < 0 || col < 0) {
        return
      }
      this.highlightRow = row
      this.highlightCol = col
      cell = (ref = this.cells[row]) != null ? ref[col] : void 0
      row -= this.start
      comp = cell.childNodes[0].__vue__
      comp = (ref1 = cell.querySelector('div')) != null ? ref1.__vue__ : void 0
      if (comp) {
        p = Promise.resolve()
      } else {
        p = this.renderCell(row, col).then(() => {
          let ref2
          return (comp = (ref2 = cell.querySelector('div')) != null ? ref2.__vue__ : void 0)
        })
      }
      // if !comp
      //   console.log row, col
      //   console.error 'comp is null, cell = ', cell
      return p.then(() => {
        if (!comp) {
          return
        }
        this.dishighlight()
        if (row < 0 || row > this.dataDisplayed.length) {
          return
        }
        this.highlightedCell = cell
        this.scrollInToView(cell)
        addClass(cell, 'highlight')
        edit && comp.edit()
        this.activeRow = comp.rowObj
        this.activeRowNum = this.start + row
        return (this.showActiveRow = true)
      })
    },
    edit(row, col) {
      let cell, comp, ref
      if ((cell = (ref = this.cells[row]) != null ? ref[col] : void 0)) {
        comp = cell.childNodes[0].__vue__
        return comp.edit()
      }
    },
    scrollTitle() {
      let left
      left = this.$refs.scroller.scrollLeft
      return (this.titleLeft = -left)
    },
    scrollFrame(l, t) {
      let scroller
      scroller = this.$refs.scroller
      if (scroller) {
        scroller.scrollLeft = l
        return (scroller.scrollTop = t)
      }
    },
    doExpand(data) {
      this.expandRowData = data
      return (this.expanded = true)
    },
    disExpand() {
      this.expandRowData = {}
      return (this.expanded = false)
    },
    setMenu(top, left) {
      // largestHeight = window.innerHeight - @$el.offsetHeight - 25
      // largestWidth = window.innerWidth - @$el.offsetWidth - 25
      // console.log largestHeight, largestWidth
      // console.log top, left
      // if (top > largestHeight)
      //   top = largestHeight
      // if (left > largestWidth)
      //   left = largestWidth
      // console.log top, left
      this.top = `${top}px`
      return (this.left = `${left}px`)
    },
    closeMenu() {
      return (this.viewMenu = false)
    },
    openMenu(e) {
      this.viewMenu = true
      this.$nextTick(() => {
        this.$refs.menu.focus()
        // @$.right.focus();
        return this.setMenu(e.y, e.x)
      })
      return e.preventDefault()
    },
    initFilter() {
      console.log(this.opts.columns)
      this.filterby = {}
      return this.opts.columns.map(col => (this.filterby[col.label] = ''))
    },
  },
  // watch:
  //   filterby:
  //     handler: (val, oldVal) ->
  //       app.config.cfg.spreadsheet[@opts.tableName+@opts.cfgId].filterby = val
  //       console.log val,1214
  //     deep: true
  created() {
    let base, base1, base2, base3, base4, base5
    if ((base = this.opts).actionbar == null) {
      base.actionbar = true
    }
    if ((base1 = this.opts).editable == null) {
      base1.editable = true
    }
    if ((base2 = this.opts).creatable == null) {
      base2.creatable = true
    }
    if ((base3 = this.opts).checkable == null) {
      base3.checkable = true
    }
    if ((base4 = this.opts).numable == null) {
      base4.numable = true
    }
    if ((base5 = this.opts).recycle == null) {
      base5.recycle = false
    }
    this.sortby = this.clone(this.opts.sortby)
    this.filterby = _.extend(this.filterby, this.opts.filterby)
    if (!this.filterby) {
      this.initFilter()
    }
    // @sortby ?= ''
    // app.config.cfg.spreadsheet[@opts.tableName] ?= {}
    // app.config.cfg.spreadsheet[@opts.tableName].columnHidden ?= {}
    // @columnHidden = app.config.cfg.spreadsheet[@opts.tableName].columnHidden
    // @opts.columns.map (col) =>
    //   @columnHidden[col.label] ?= false
    this.arrowKeyHandler = e => {
      let col, row
      if (this.highlightRow == null) {
        this.highlightRow = 0
      }
      if (this.highlightCol == null) {
        this.highlightCol = 0
      }
      if (this.expandedEditorEditing) {
        return
      }
      if (e.ctrlKey) {
        switch (e.code) {
          case 'ArrowUp':
            if (this.highlightRow > 0 && this.rowExist(this.highlightRow - 1)) {
              row = this.highlightRow - 1
              col = this.highlightCol
              return this.highlight(row, col, false)
            }
            break
          case 'ArrowDown':
            if (this.highlightRow < this.data.length - 1 && this.rowExist(this.highlightRow + 1)) {
              e.preventDefault()
              row = this.highlightRow + 1
              col = this.highlightCol
              return this.highlight(row, col, false)
            }
            break
          case 'ArrowLeft':
            if (this.highlightCol > 0) {
              row = this.highlightRow
              col = this.highlightCol - 1
              return this.highlight(row, col, false)
            }
            break
          case 'ArrowRight':
            if (this.highlightCol < this.shownColumns.length - 1) {
              row = this.highlightRow
              col = this.highlightCol + 1
              return this.highlight(row, col, false)
            }
            break
          case 'Enter':
            return this.edit(this.highlightRow, this.highlightColss)
        }
      }
    }
    this.shiftKeyDown = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = true)
      }
    }
    this.shiftKeyUp = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = false)
      }
    }
    document.addEventListener('keydown', this.arrowKeyHandler)
    document.addEventListener('keydown', this.shiftKeyDown)
    return document.addEventListener('keyup', this.shiftKeyUp)
  },
  // @init()
  destroyed() {
    document.removeEventListener('keydown', this.arrowKeyHandler)
    document.removeEventListener('keydown', this.shiftKeyDown)
    return document.removeEventListener('keyup', this.shiftKeyUp)
  },
  mounted() {
    if (this.refreshFilter) {
      this.initFilter()
    }
    this.opts.checked = false
    this.init()
    return this.onscroll()
  },
})
</script>

<style>
.right-click-menu {
  background: #fafafa;
  border: 1px solid #555;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 250px;
  z-index: 999999;
}

.right-click-menu li {
  border-bottom: 1px solid #e0e0e0;
  margin: 0;
  padding: 5px 35px;
}

.right-click-menu li:last-child {
  border-bottom: none;
}

.right-click-menu li:hover {
  background: #1e88e5;
  color: #fafafa;
  cursor: pointer;
}
</style>
